"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const tslib_1 = require("tslib");
const deepmerge_1 = tslib_1.__importDefault(require("deepmerge"));
const lodash_isnil_1 = tslib_1.__importDefault(require("lodash.isnil"));
const utils_1 = require("../utils");
const useBlueBase_1 = require("./useBlueBase");
const useTheme_1 = require("./useTheme");
function useStyles(componentName, props = {}, defaultStyles) {
    const BB = useBlueBase_1.useBlueBase();
    const { theme } = useTheme_1.useTheme();
    const { styles: stylesProp } = props, rest = tslib_1.__rest(props, ["styles"]);
    // Find styles in the component registry
    const stylesParam = BB.Components.getStyles(componentName);
    // Extract component style rules from theme
    let themedStyles;
    if (componentName) {
        const themeComponentStyles = theme.components;
        // Extract style rules for this component
        themedStyles = themeComponentStyles[componentName];
    }
    // Put all style rules in an array
    const stylesArr = [defaultStyles, stylesParam, themedStyles, stylesProp]
        // Remove those styles which are nil
        .filter((a) => !lodash_isnil_1.default(a))
        // If any item is a thunk, resolve it
        .map((a) => a && utils_1.resolveThunk(a, theme, rest));
    // Merge all into a single object
    const styles = deepmerge_1.default.all(stylesArr);
    return styles;
}
exports.useStyles = useStyles;
